// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.multiplex.amenities.RentalManagerUserPropertyMultiplexAmenityWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyMultiplexAmenityCreateResponseWebDto,
  UserPropertyMultiplexAmenityDeleteResponseWebDto,
} from '../..';

interface CreateParams {
  multiplexBuildingSessionId: string;
  text: string;
}
interface DeleteParams {
  amenityId: string;
  multiplexBuildingSessionId: string;
}

export const RentalManagerUserPropertyMultiplexAmenityWebApiHandler_create_Path =
  '/api/web/v1/users/properties/multiplex/amenities/create';

/**
 * Create a free text property amenity on every unit in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexAmenityWebApiHandler_create = (
  getParams: CreateParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CreateParams, never, UserPropertyMultiplexAmenityCreateResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexAmenityWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexAmenityWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/multiplex/amenities/delete';

/**
 * Delete a free text property amenity from every unit in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexAmenityWebApiHandler_delete = (
  getParams: DeleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeleteParams, never, UserPropertyMultiplexAmenityDeleteResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyMultiplexAmenityWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
